import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable()
export class MetaDataService {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private title: Title,
  )
  {}

  public setFavicon(faviconUrl: string): void {
    this.document.getElementById('site-favicon')?.setAttribute('href', faviconUrl);
  }

  public setTitle(siteName: string): void {
    this.title.setTitle(`${siteName}`);
  }
}
